import { render, staticRenderFns } from "./ValidationShoppingCart.vue?vue&type=template&id=9d72ab8a&"
import script from "./ValidationShoppingCart.vue?vue&type=script&lang=js&"
export * from "./ValidationShoppingCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports